<template>
  <div>

    <!--Stats cards-->
    <div class="row">
      <div class="col-md-6 col-xl-3" v-if="item.stories && item.stories.total">
        <stats-card>
          <div class="icon-big text-center icon-success" slot="header">
            <i class="far fa-comments"/>
          </div>
          <div class="numbers" slot="content">
            <p>نظرات درانتظار تایید</p>
            {{ item.comments.total_pending_count}}
          </div>
        </stats-card>
      </div>
      <div class="col-md-6 col-xl-3" v-if="item.stories && item.stories.total">
        <stats-card>
          <div class="icon-big text-center icon-success" slot="header">
            <i class="far fa-kiss-beam"/>
          </div>
          <div class="numbers" slot="content">
            <p>داستان ها</p>
            {{ item.stories.total}}
          </div>
        </stats-card>
      </div>
      <div class="col-md-6 col-xl-3" v-if="item.accounts && item.accounts.total">
        <stats-card>
          <div class="icon-big text-center icon-warning" slot="header">
            <i class="fas fa-users"/>
          </div>
          <div class="numbers" slot="content">
            <p>کاربران</p>
            {{ item.accounts.total}}
          </div>
        </stats-card>
      </div>
      <div class="col-md-6 col-xl-3" v-if="item.categories && item.categories.total">
        <stats-card>
          <div class="icon-big text-center icon-info" slot="header">
            <i class="fa fa-list-alt"/>
          </div>
          <div class="numbers" slot="content">
            <p>تعداد دسته بندی ها</p>
            {{ item.categories.total}}
          </div>
        </stats-card>
      </div>
    </div>

<!--    &lt;!&ndash;Charts&ndash;&gt;-->
<!--    <div class="row">-->

<!--      <div class="col-12">-->
<!--        <chart-card title="Users behavior"-->
<!--                    sub-title="24 Hours performance"-->
<!--                    :chart-data="usersChart.data"-->
<!--                    :chart-options="usersChart.options">-->
<!--          <span slot="footer">-->
<!--            <i class="ti-reload"></i> Updated 3 minutes ago-->
<!--          </span>-->
<!--          <div slot="legend">-->
<!--            <i class="fa fa-circle text-info"></i> Open-->
<!--            <i class="fa fa-circle text-danger"></i> Click-->
<!--            <i class="fa fa-circle text-warning"></i> Click Second Time-->
<!--          </div>-->
<!--        </chart-card>-->
<!--      </div>-->

<!--      <div class="col-md-6 col-12">-->
<!--        <chart-card title="نمودار کاربران"-->
<!--                    :chart-data="preferencesChart.data"-->
<!--                    chart-type="Pie">-->

<!--          <span slot="footer">-->
<!--            <i class="ti-timer"/> Campaign set 2 days ago-->
<!--          </span>-->
<!--          <div slot="legend">-->
<!--            <i class="fa fa-circle text-info"/> Open-->
<!--            <i class="fa fa-circle text-danger"/> Bounce-->
<!--            <i class="fa fa-circle text-warning"/> Unsubscribe-->
<!--          </div>-->
<!--        </chart-card>-->
<!--      </div>-->

<!--      <div class="col-md-6 col-12">-->
<!--        <chart-card title="2015 Sales"-->
<!--                    sub-title="All products including Taxes"-->
<!--                    :chart-data="activityChart.data"-->
<!--                    :chart-options="activityChart.options">-->
<!--          <span slot="footer">-->
<!--            <i class="ti-check"></i> Data information certified-->
<!--          </span>-->
<!--          <div slot="legend">-->
<!--            <i class="fa fa-circle text-info"></i> Tesla Model S-->
<!--            <i class="fa fa-circle text-warning"></i> BMW 5 Series-->
<!--          </div>-->
<!--        </chart-card>-->
<!--      </div>-->

<!--    </div>-->

  </div>
</template>
<script>
  import {StatsCard, ChartCard} from "@/components/index";
  import Chartist from 'chartist';
  import {mapActions} from "vuex";

  export default {
    components: {
      StatsCard,
      ChartCard
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data() {
      return {
        ...mapActions('main', [
          'crud'
        ]),
        usersChart: {
          data: {
            labels: [
              "9:00AM",
              "12:00AM",
              "3:00PM",
              "6:00PM",
              "9:00PM",
              "12:00PM",
              "3:00AM",
              "6:00AM"
            ],
            series: [
              [287, 385, 490, 562, 594, 626, 698, 895, 952],
              [67, 152, 193, 240, 387, 435, 535, 642, 744],
              [23, 113, 67, 108, 190, 239, 307, 410, 410]
            ]
          },
          options: {
            low: 0,
            high: 1000,
            showArea: true,
            height: "245px",
            axisX: {
              showGrid: false
            },
            lineSmooth: Chartist.Interpolation.simple({
              divisor: 3
            }),
            showLine: true,
            showPoint: false
          }
        },
        activityChart: {
          data: {
            labels: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "Mai",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec"
            ],
            series: [
              [542, 543, 520, 680, 653, 753, 326, 434, 568, 610, 756, 895],
              [230, 293, 380, 480, 503, 553, 600, 664, 698, 710, 736, 795]
            ]
          },
          options: {
            seriesBarDistance: 10,
            axisX: {
              showGrid: false
            },
            height: "245px"
          }
        },
        preferencesChart: {
          data: {
            labels: ["62%", "32%", "6%"],
            series: [62, 32, 6]
          },
          options: {}
        },
        item: {},
      };
    },
    computed: {

    },
    methods: {
      async getData() {
        this.$store.commit('main/SET', {key: 'loading', value: true})
        try {
          const item = await this.crud({
            action: 'get',
            section: 'dashboard',
          })
          this.item = item.data
          if (item.data.accounts && Object.keys(item.data.accounts).length > 0 && Object.keys(item.data.accounts.roles).length > 0) {
            const preferencesChart = {
              data: {
                labels: ["62%", "32%", "6%"],
                series: [62, 32, 6]
              },
              options: {}
            }
            const accounts = item.data.accounts
            // console.log(accounts.total)
            const series = await Object.keys(accounts.roles).map(val => {
              // console.log(accounts.roles[val])
              return (accounts.roles[val] / accounts.total)
            } )
            // console.log(series)
          }
        } catch (e) {
          // console.log(e)
        } finally {
          this.$store.commit('main/SET', {key: 'loading', value: false})
        }
      },
    },
    async created() {
      await this.getData()
    },
    mounted() {
    }
  };
</script>
<style>
</style>
